import { clearSchoolOnboardingDraft } from './school-onboarding-draft';
import { clearMunicipalityOnboardingDraft } from './municipality-onboarding-draft';
import { clearAuthorityProfileDraft } from './authority-profile-draft';
import { clearProfileWizardDraft } from '../profiles/profile-wizard/profile-wizard-draft';
import { clearMunicipalityPlanSelection } from './municipality-plan-selection';
import { clearMunicipalityPlanDraft } from './municipality-plan-onboarding/municipality-plan-draft';
import { clearCompleteOrderOnboardingDraft } from './complete-order-onboarding/complete-order-draft';
import { clearAuthorityNewFlowFlag } from './authority-new-flow';
import { clearFachkraftUpgradeOrderProcessDraft } from '../../dialogs/order-process/fachkraft-upgrade-draft';

/**
 * Clears all session-scoped onboarding / profile-wizard drafts and related flags.
 * Use on auth boundaries: verify-email, successful signup/login, Edulog, email action links.
 */
export function clearAllOnboardingSessionStores(): void {
  clearSchoolOnboardingDraft();
  clearMunicipalityOnboardingDraft();
  clearAuthorityProfileDraft();
  clearProfileWizardDraft();
  clearMunicipalityPlanSelection();
  clearMunicipalityPlanDraft();
  clearCompleteOrderOnboardingDraft();
  clearAuthorityNewFlowFlag();
  clearFachkraftUpgradeOrderProcessDraft();
}

export type WelcomeOnboardingRole =
  | 'fachkraft'
  | 'schuleinheit'
  | 'schulgemeinde';

/**
 * When the user explicitly picks a role on `/welcome`, drop drafts from other paths so
 * session data from a previous choice or account does not leak into the new flow.
 */
export function clearStaleOnboardingDraftsForWelcomeRole(
  role: WelcomeOnboardingRole
): void {
  clearMunicipalityPlanSelection();
  clearMunicipalityPlanDraft();
  clearCompleteOrderOnboardingDraft();
  clearAuthorityNewFlowFlag();
  clearFachkraftUpgradeOrderProcessDraft();
  if (role === 'fachkraft') {
    clearSchoolOnboardingDraft();
    clearMunicipalityOnboardingDraft();
    clearAuthorityProfileDraft();
    clearProfileWizardDraft();
  } else if (role === 'schuleinheit') {
    clearMunicipalityOnboardingDraft();
    clearAuthorityProfileDraft();
  } else {
    clearSchoolOnboardingDraft();
    clearMunicipalityOnboardingDraft();
    clearAuthorityProfileDraft();
    clearProfileWizardDraft();
  }
}
